// extracted by mini-css-extract-plugin
module.exports = {"search":"Icons_search__31djx","close":"Icons_close__367Y4"};